export const entity = {
    name: 'Function',
    facets: ['codeName'],
    fields: [
        {path: 'submissionAuthorization', type: 'boolean'},
        {path: 'studyAuthorization', type: 'boolean'},
        {path: 'decisionAuthorization', type: 'boolean'},
        {path: 'solicitationsManagementAuthorization', type: 'boolean'}, //paymentAuthorization
        {path: 'liberationAuthorization', type: 'boolean'},
        {path: 'adhesionProcessAdministrator', type: 'boolean'},
        {path: 'liberalityProcessAdministrator', type: 'boolean'},
        {path: 'eligibleToAssociation', type: 'boolean'},
        {path: 'eligibleToVisit', type: 'boolean'}
    ],
    filters: [
        {
            name: "eligibleToAssociation",
            isDefault: false,
            query: () => ({eligibleToAssociation: true})
        },
        {
            name: "adhesionProcessAdministrator",
            isDefault: false,
            query: () => ({adhesionProcessAdministrator: true})
        },
        {
            name: "liberalityProcessAdministrator",
            isDefault: false,
            query: () => ({liberalityProcessAdministrator: true})
        },
        {
            name: "eligibleToVisit",
            isDefault: false,
            query: () => ({eligibleToVisit: true})
        }
    ]
}


export const module_ = {
    object: 'Function',
    tKey: 'mTitle_function',
    category: {
        path: 'menuTitle_configuration',
        icon: 'settings'
    },
    viewMap: {
        dt: [
            {path: 'code', width: 80},
            {path: 'name', width: 120},
            {path: 'submissionAuthorization', tKey: 'submission'},
            {path: 'studyAuthorization', tKey: 'study'},
            {path: 'decisionAuthorization', tKey: 'decision'},
            {path: 'solicitationsManagementAuthorization', tKey: 'solicitationsManagement'},
            {path: 'liberationAuthorization', tKey: 'liberationManagement'},
            {path: 'liberalityProcessAdministrator', tKey: 'liberality'},
            {path: 'adhesionProcessAdministrator', tKey: 'Adhésion - Administration'},
            {path: 'eligibleToVisit', tKey: 'Adhésion - Visite'},
            {path: 'eligibleToAssociation', width: 150}
        ],
        form: [
            {path: 'code'},
            {path: 'name'},
            {path: 'submissionAuthorization'},
            {path: 'studyAuthorization'},
            {path: 'decisionAuthorization'},
            {path: 'solicitationsManagementAuthorization'},
            {path: 'liberationAuthorization'},
            {path: 'liberalityProcessAdministrator'},
            {path: 'adhesionProcessAdministrator'},
            {path: 'eligibleToVisit', tKey: "adhesionProcessVisitor"},
            {path: 'eligibleToAssociation'},
        ]
    }
}
